// extracted by mini-css-extract-plugin
export default {"header":"Header_header__hZRwL","logo":"Header_logo__odlHd","items":"Header_items__z9HEa"};